import axios from 'axios'
import { cautionUrl, IhLogUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

// 告警用户明细以及总数统计
export function alertCountPage(params) {
  const url = cautionUrl + '/alert/count/user/page'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设置》数据中心', '查询告警用户明细以及总数', res)
    }
    return Promise.resolve(res.data)
  })
}
// 告警用户明细以及总数统计(一键求助类型)
export function emergencyHelpPage(params) {
  const url = IhLogUrl + '/emergencyHelp/count/user/page'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设置》数据中心', '查询告警用户明细以及总数(一键求助类型)', res)
    }
    return Promise.resolve(res.data)
  })
}
